import {
  Component,
  Inject,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { Itinerary, ItineraryAttraction } from '../../../models/itinerary';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgForOf, NgIf } from '@angular/common';
import { MatCheckbox } from '@angular/material/checkbox';
import { SharedModule } from '../../../../shared/shared.module';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { ButtonTriggerEvent } from '../../../../../common/components/button/button.component';
import { TripPlannerService } from '../../../services/trip.planner.service';
import { clone } from '../../../../../common/utils/object.extensions';

@Component({
  selector: 'ig-attraction-description-preview-modal',
  standalone: true,
  imports: [NgIf, MatCheckbox, NgForOf, SharedModule],
  templateUrl: './attraction.description.preview.modal.component.html',
  styleUrl: './attraction.description.preview.modal.component.scss',
})
export class AttractionDescriptionPreviewModalComponent {
  data: AttractionDescriptionPreviewModalData;
  form: FormGroup;
  editingAttraction: ItineraryAttraction;
  editingField: 'pre' | 'post' | 'desc';
  initialItinerary: Itinerary;
  descriptionChangedAttractionIds: string[] = [];

  @ViewChildren('editMenuTrigger') editMenuTriggers: QueryList<MatMenuTrigger>;

  constructor(
    private _fb: FormBuilder,
    private _tripService: TripPlannerService,
    private dialogRef: MatDialogRef<AttractionDescriptionPreviewModalComponent>,
    @Inject(MAT_DIALOG_DATA) data: AttractionDescriptionPreviewModalData
  ) {
    this.data = Object.assign({}, data);
    this.initialItinerary = clone(data.itinerary);

    console.log('this.data', this.data);

    this.form = this._fb.group({
      text: [null, []],
    });
  }

  isJustGenerated(attractionId: string, type: 'pre' | 'post' | 'desc') {
    return this.data.selectedItems.find((x) => x.id === attractionId)?.[type];
  }

  edit(attraction: ItineraryAttraction, type: 'pre' | 'post' | 'desc') {
    // const item = this.data.itinerary.attractions.find(x => x._id === attractionId);
    console.log('attraction', attraction);
    this.editingAttraction = attraction;
    this.editingField = type;
    this.form
      .get('text')
      .setValue(
        type === 'desc'
          ? attraction.item.description
          : type === 'pre'
          ? attraction.preDescription
          : attraction.postDescription
      );
  }

  setText() {
    const text = this.form.get('text').value;
    if (this.editingField === 'desc')
      this.editingAttraction.item.description = text;
    if (this.editingField === 'pre')
      this.editingAttraction.preDescription = text;
    if (this.editingField === 'post')
      this.editingAttraction.postDescription = text;

    if (this.editMenuTriggers) {
      this.editMenuTriggers.forEach((x) => x.closeMenu());
    }
  }

  save(event: ButtonTriggerEvent) {
    this.descriptionChangedAttractionIds = [];

    let index = 0;
    for (const attraction of this.data.itinerary.attractions) {
      console.log('attraction', attraction.item.name);
      console.log('attraction.item.description', attraction.item.description);
      console.log(
        'this.initialItinerary.attractions[index].item',
        this.initialItinerary.attractions[index].item.description
      );
      // if (
      //   attraction.item.description !==
      //   this.initialItinerary.attractions[index].item.description
      // ) {
      //   this.descriptionChangedAttractionIds.push(attraction.item._id);
      // }
      this.descriptionChangedAttractionIds.push(attraction.item._id);
      index++;
    }

    this._tripService
      .updateItineraryAttractions(
        this.data.hubName,
        this.data.itinerary._id,
        this.data.itinerary.attractions,
        this.descriptionChangedAttractionIds
      )
      .pipe()
      .subscribe(() => {
        event.success();

        // notify itinerary.details.modal to reset change status
        TripPlannerService.sendData({
          type: 'ATTRACTION_DESCRIPTION_SAVED',
          data: null,
        });

        this.data?.parentTrigger?.closeMenu();
        setTimeout(() => {
          this.dialogRef.close();
        }, 5000);
      });
  }

  getEditingTitle() {
    return `Edit ${this.getTypeText()} of ${
      this.editingAttraction?.item?.name
    }`;
  }

  getTypeText() {
    if (this.editingField === 'desc') return 'Description';
    if (this.editingField === 'pre') return 'Pre-Description';
    if (this.editingField === 'post') return 'Post-Description';
    return '';
  }
}

export interface AttractionDescriptionPreviewModalData {
  itinerary: Itinerary;
  selectedItems: any;
  hubName: string;
  parentTrigger?: MatMenuTrigger;
}
